import type { StateCreator } from 'zustand';

import type { WorkspaceStore } from '../workspaceStore';
import {
  emptyWorkspaceAssetsSnapshot,
  type WorkspaceAssetsSnapshot,
} from '../types';
import { getWorkspaceAssetsRuntime } from '../workspaceAssetsRuntime';

export type AssetsSlice = {
  assetsByWorkspace: Record<string, WorkspaceAssetsSnapshot>;
  setAssetsSnapshot: (
    workspaceId: string,
    patch: Partial<WorkspaceAssetsSnapshot>
  ) => void;
  retainWorkspaceAssets: (workspaceId: string) => () => void;
  resetWorkspaceAssets: (workspaceId?: string) => void;
};

export const createAssetsSlice: StateCreator<
  WorkspaceStore,
  [],
  [],
  AssetsSlice
> = (set, get) => ({
  assetsByWorkspace: {},
  setAssetsSnapshot: (workspaceId, patch) =>
    set(state => ({
      assetsByWorkspace: {
        ...state.assetsByWorkspace,
        [workspaceId]: {
          ...(state.assetsByWorkspace[workspaceId] ??
            emptyWorkspaceAssetsSnapshot()),
          ...patch,
        },
      },
    })),
  retainWorkspaceAssets: workspaceId => {
    const runtime = getWorkspaceAssetsRuntime(workspaceId, (id, patch) => {
      get().setAssetsSnapshot(id, patch);
    });
    return runtime.retain();
  },
  resetWorkspaceAssets: workspaceId => {
    if (!workspaceId) {
      set({ assetsByWorkspace: {} });
      return;
    }
    set(state => {
      const next = { ...state.assetsByWorkspace };
      delete next[workspaceId];
      return { assetsByWorkspace: next };
    });
  },
});
